import { createApp } from 'vue/dist/vue.esm-bundler'
import { defineAsyncComponent } from 'vue'
import { createPinia } from 'pinia'
import ymapsVueComponents from 'ymaps-vue-components'
// import useFormsStore from './components/forms/useFormsStore';
import { useI18n } from '@/composables/useI18n/useI18n.js';

window.createApp = createApp;

const App = {
    data() {
        return {
            formSubject: '',
            formCode: '',
        }
    },
    methods: {
        setformSubject(subject, code) {
            this.formSubject = subject;
            this.formCode = code;
        }
    },
    components: {
        AuthForgotPassword: defineAsyncComponent({
            loader: () => import('./components/forms/AuthForgotPassword'),
        }),
        AuthChangePassword: defineAsyncComponent({
            loader: () => import('./components/forms/AuthChangePassword'),
        }),
        AuthLogin: defineAsyncComponent({
            loader: () => import('./components/forms/AuthLogin'),
        }),
        AuthRegistration: defineAsyncComponent({
            loader: () => import('./components/forms/AuthRegistration'),
        }),
        PersonalData: defineAsyncComponent({
            loader: () => import('./components/personal/PersonalData'),
        }),
        PersonalDelete: defineAsyncComponent({
            loader: () => import('./components/personal/PersonalDelete'),
        }),
        PersonalEditPassword: defineAsyncComponent({
            loader: () => import('./components/personal/PersonalEditPassword'),
        }),
        PersonalOrganizations: defineAsyncComponent({
            loader: () => import('./components/personal/PersonalOrganizations'),
        }),
        PersonalSubscribe: defineAsyncComponent({
            loader: () => import('./components/personal/PersonalSubscribe'),
        }),
        PersonalHelpMoney: defineAsyncComponent({
            loader: () => import('./components/forms/PersonalHelpMoney'),
        }),
        PersonalHelpNetwork: defineAsyncComponent({
            loader: () => import('./components/forms/PersonalHelpNetwork'),
        }),
        PersonalHelpStaff: defineAsyncComponent({
            loader: () => import('./components/forms/PersonalHelpStaff'),
        }),
        PersonalHelpPlace: defineAsyncComponent({
            loader: () => import('./components/forms/PersonalHelpPlace'),
        }),
        PersonalHelpQuestion: defineAsyncComponent({
            loader: () => import('./components/forms/PersonalHelpQuestion'),
        }),
        Investkarta: defineAsyncComponent({
            loader: () => import('./components/investkarta/List'),
        }),
        MainFeedback: defineAsyncComponent({
            loader: () => import('./components/forms/MainFeedback'),
        }),
        LineFeedback: defineAsyncComponent({
            loader: () => import('./components/forms/LineFeedback'),
        }),
        LineFeedbackForm: defineAsyncComponent({
            loader: () => import('./components/forms/LineFeedbackForm'), // аналогично попапу, но вынесено на отдельную страницу
        }),
        RegisterEvent: defineAsyncComponent({
            loader: () => import('./components/forms/RegisterEvent'),
        }),
        ConsultFeedback: defineAsyncComponent({
            loader: () => import('./components/forms/ConsultFeedback'),
        }),
        ConsultFeedbackForm: defineAsyncComponent({
            loader: () => import('./components/forms/ConsultFeedbackForm'), // аналогично попапу, но вынесено на отдельную страницу
        }),
        ConsultFeedbackButtom: defineAsyncComponent({
            loader: () => import('./components/forms/ConsultFeedbackButtom'),
        }),
        ConsultFeedbackSupport: defineAsyncComponent({
            loader: () => import('./components/forms/ConsultFeedbackSupport'),
        }),
        NavigatorSupport: defineAsyncComponent({
            loader: () => import('./components/navigator/Filter'),
        }),
        NavigatorSupportEn: defineAsyncComponent({
            loader: () => import('./components/navigator/FilterEn'),
        }),
        NavigatorSupportZh: defineAsyncComponent({
            loader: () => import('./components/navigator/FilterZh'),
        }),
        PersonalAppeal: defineAsyncComponent({
            loader: () => import('./components/forms/PersonalAppeal'),
        }),
        PersonalAppealEn: defineAsyncComponent({
            loader: () => import('./components/forms/PersonalAppealEn'),
        }),
        PersonalAppealZh: defineAsyncComponent({
            loader: () => import('./components/forms/PersonalAppealZh'),
        }),
        RegisterAccomodation: defineAsyncComponent({
            loader: () => import('./components/forms/RegisterAccomodation'),
        }),
        AnalyticsList: defineAsyncComponent({
            loader: () => import('./components/AnalyticsList'),
        }),
        GchpList: defineAsyncComponent({
            loader: () => import('./components/GchpList'),
        }),
        EventsCalendar: defineAsyncComponent({
            loader: () => import('./components/EventsCalendar')
        }),
        EvaluateFeedback: defineAsyncComponent({
            loader: () => import('./components/forms/EvaluateFeedback'),
        }),
        MunicipalSection: defineAsyncComponent({
            loader: () => import('./components/municipal-map/MunicipalSection'),
        }),
        ProjectsView: defineAsyncComponent({
            loader: () => import('./components/projects/ProjectsView'),
        }),
        StaffIssueForm: defineAsyncComponent({
            loader: () => import('./components/forms/StaffIssueForm'),
        }),
        InvestCommitteePopupForm: defineAsyncComponent({
            loader: () => import('./components/forms/InvestCommitteePopupForm'),
        }),
        InvestCommitteeForm: defineAsyncComponent({
            loader: () => import('./components/forms/InvestCommitteeForm'), // аналогично попапу, но вынесено на отдельную страницу
        }),
        JurConsultForm: defineAsyncComponent({
            loader: () => import('./components/forms/JurConsultForm'),
        }),
    },
    mounted() {
        setTimeout(() => {
            window.initSlimSelect('.default-select__select');
        }, 100)
    }
}

window.addEventListener('DOMContentLoaded', async () => {
    const { initI18n } = useI18n();
    const lang = document.documentElement.lang || 'ru';
    await initI18n(lang);

    const app = createApp(App)
    const pinia = createPinia()
    app.use(ymapsVueComponents)
    app.use(pinia)
    app.mount('#app')
    if (window.initUI) window.initUI();
})